import PropTypes from 'prop-types';
import { articleTilePropTypes } from './components/ArticleTile/ArticleTilePropTypes';
export const similarArticlesPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Array of ArticleTile data - picture, category, date, heading, href, description, isLarge
   */
  items: PropTypes.arrayOf(PropTypes.shape(articleTilePropTypes))
};